import { Container } from 'unstated'

export default class WorkoutStore extends Container {
  state = {
    questionBankId: undefined,
    workoutComplete: false,
    displayAnswer: false,
    workouts: {},
  }

  startWorkout = ({ questionBankId, questions }) => {
    const { workouts } = this.state
    this.setState({
      questionBankId,
      workoutComplete: false,
      workouts: {
        ...workouts,
        [questionBankId]: {
          questions,
          questionIndex: 0,
        },
      },
    })
  }

  exitWorkout = () => {
    this.setState({
      questionBankId: undefined,
      workoutComplete: false,
      displayAnswer: false,
    })
  }

  setQuestionResponse = ({ questionBankId, questionId, boxId }) => {
    const { workouts } = this.state

    const thisWorkout = workouts[questionBankId] || {}
    const updatedQuestions = thisWorkout.questions.map(question => {
      if (question.id === questionId) {
        return {
          ...question,
          response: boxId,
        }
      } else {
        return {
          ...question,
        }
      }
    })

    const newState = {
      ...this.state,
      workouts: {
        ...workouts,
        [questionBankId]: {
          ...thisWorkout,
          questions: updatedQuestions,
        },
      },
    }
    this.setState(newState)
  }

  revealAnswer = () => {
    this.setState({
      displayAnswer: true,
    })
  }

  goToNextQuestion = () => {
    const { questionBankId, workouts } = this.state
    const thisWorkout = workouts[questionBankId]
    const nextIndex = thisWorkout.questionIndex + 1
    const workoutComplete = !!(nextIndex === thisWorkout.questions.length)
    this.setState({
      workoutComplete,
      displayAnswer: false,
      workouts: {
        ...workouts,
        [questionBankId]: {
          questions: workouts[questionBankId].questions,
          questionIndex: nextIndex,
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/WorkoutStore.js